/**
 * 3 D Thouch const symbols.
 * @constant
 * @type {Object}
 */
const T3D_TOUCH = {
    ACT_QUICK_DEPOSIT: 'QuickDeposit',
    ACT_LOGIN: 'Login',
    ACT_PLAY_GAME: 'PlayGame',
    ACTION: 'action',
    CAPTION: 'caption',
    VAL: 'val',
    CLIENT_ACTION: 'clientAction',
    CLIENT_VAL: 'clientVal',
    INIT_GAME_ID: 'initGameId',
    RECENTLY_PLAYED_GAME_ID: 'recentlyPlayedGameId'
};


export {T3D_TOUCH};